module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "do-table do-table__user-employments",
    class: {
      'do-table__user-employments--import': _vm.isSalaryIntegrationActive
    }
  }, [_c('thead', [(!_vm.isSalaryIntegrationActive) ? _c('th', {
    staticClass: "do-table__toggle-all",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.selectedUsers.length === 0) ? [_vm._v("\n      " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n    ")] : [_vm._v("\n      " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n    ")]], 2) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Vikarløn")])]), _vm._v(" "), _c('tbody', {
    ref: "d-b"
  }, [_vm._l((_vm.filteredUsers), function(user) {
    return (_vm.isSalaryIntegrationActive) ? [_c('tbody', {
      key: 'user-' + user.id,
      staticClass: "user-group"
    }, [_vm._l((user.v_employments), function(employment, key) {
      return _c('tr', {
        key: 'employment-' + employment.id,
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.setTheEditUser(user)
          }
        }
      }, [_c('td', [(key === 0) ? [_c('strong', [_vm._v(_vm._s(user.name))])] : _vm._e()], 2), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "d-tag d-tag--inline",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('editEmployment', {
              user: user,
              employment: employment
            })
          }
        }
      }, [_vm._v(_vm._s(employment.title))])]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(employment.organisation))]), _vm._v(" "), (_vm.isSalaryIntegrationActive && (!employment.default_loebenummer || !employment.default_loenart)) ? _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            placement: 'left',
            arrow: true,
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window',
            onShow: function () { return !employment.default_loebenummer || !employment.default_loenart; }
          }),
          expression: "{\n        placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !employment.default_loebenummer || !employment.default_loenart\n            }"
        }],
        attrs: {
          "content": "Løbenummer og lønart skal udfyldes "
        }
      }, [_c('div', {
        staticClass: "toggle-flex toggle-flex--disabled",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('editEmployment', {
              user: user,
              employment: employment
            })
          }
        }
      }, [_c('AppToggle', {
        attrs: {
          "prop-on": employment.manual_salary,
          "allow-changes": false
        }
      }), _vm._v(" "), (employment.manual_salary) ? _c('span', {
        staticClass: "do-pill do-pill--small do-pill--yellow"
      }, [_vm._v("Vikarløn")]) : _vm._e()], 1)]) : _c('td', [_c('div', {
        staticClass: "toggle-flex",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('editEmployment', {
              user: user,
              employment: employment,
              context: 'manual_salary'
            })
          }
        }
      }, [_c('AppToggle', {
        attrs: {
          "prop-on": employment.manual_salary,
          "allow-changes": false
        }
      }), _vm._v(" "), (employment.manual_salary) ? _c('span', {
        staticClass: "do-pill do-pill--small do-pill--yellow"
      }, [_vm._v("Vikarløn")]) : _vm._e()], 1)])])
    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('tr', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheEditUser(user)
        }
      }
    }, [_c('td', [_c('b', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e()], 2)] : _vm._l((_vm.filteredUsers), function(user) {
      return _c('tr', {
        key: user.id,
        on: {
          "click": function($event) {
            return _vm.toggleUser(user)
          }
        }
      }, [(!_vm.isSalaryIntegrationActive) ? _c('td', [_c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': user.v_isSelected
        }
      })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
        staticClass: "d-tags"
      }, [_vm._l((user.v_employments), function(employment) {
        return _c('div', {
          staticClass: "d-tag",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.setTheEditUser(user)
            }
          }
        }, [_vm._v("\n          " + _vm._s(employment.title) + "\n          "), (employment.organisation) ? _c('div', {
          staticClass: "d-tag d-tag--inner"
        }, [_vm._v(_vm._s(employment.organisation))]) : _vm._e(), _vm._v(" "), (employment.manual_salary) ? _c('div', {
          staticClass: "do-pill do-pill--small do-pill--yellow"
        }, [_vm._v("Vikarløn")]) : _vm._e()])
      }), _vm._v(" "), (user.v_employments.length === 0 && _vm.isShowNoEmploymentsText) ? _c('p', {
        staticClass: "italic font-small"
      }, [_vm._v("Ingen\n          ansættelser")]) : _vm._e()], 2), _vm._v(" "), _c('td', [(user.v_employments.length > 0) ? _c('div', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window'
          }),
          expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
        }],
        staticClass: "icon__bg-circle",
        attrs: {
          "content": "Redigér ansættelser"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.setTheEditUser(user)
          }
        }
      }, [_c('span', {
        staticClass: "icon-wrench"
      })]) : _vm._e()])])
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-674316b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsersOpusTable.vue
// module id = 1623
// module chunks = 1